// Groot resmi firma bilgileri — fiş, fatura, makbuz, irsaliye, barkod ve tüm belgelerde kullanılır.
import grootLogo from "@/assets/groot-logo.png";
export const COMPANY = {
  brand: "Groot Market ve Toptan",
  legal: "Groot Games Teknoloji A.Ş.",
  address: "Şerifali Mah. Kutup Sok. No : 44 / 1",
  taxLine: "V.D/N : Sarıgazi - 411 102 1165",
  web: "grootmarket.com",
  phone: "0216 528 00 00",
  email: "info@grootmarket.com",
  bankName: "Ziraat Bankası",
  accountName: "Groot Games Teknoloji A.Ş.",
  iban: "TR33 0001 0000 0000 0000 0000 01",
  tagline: "Taze · Uygun · Güvenilir",
};

const origin = () => (typeof window !== "undefined" ? window.location.origin : "https://grootmarket.com");

// ---------------- Sistem Para Birimi (₺/$/€/£) ----------------
// Seçili para birimi Sistem Yönetimi > Kur & Yakıt'tan ayarlanır; AuthContext girişte localStorage'a önbelleğe alır.
export const CURRENCIES = {
  TRY: { symbol: "₺", label: "Türk Lirası", code: "TRY", suffix: true },
  USD: { symbol: "$", label: "ABD Doları", code: "USD", suffix: false },
  EUR: { symbol: "€", label: "Euro", code: "EUR", suffix: false },
  GBP: { symbol: "£", label: "İngiliz Sterlini", code: "GBP", suffix: false },
};
export function activeCurrency() {
  try { const c = (typeof localStorage !== "undefined" && localStorage.getItem("groot_currency")) || "TRY"; return CURRENCIES[c] ? c : "TRY"; }
  catch { return "TRY"; }
}
export function setActiveCurrency(code) {
  try { if (typeof localStorage !== "undefined") localStorage.setItem("groot_currency", CURRENCIES[code] ? code : "TRY"); } catch { /* yoksay */ }
}
export const curSym = () => (CURRENCIES[activeCurrency()] || CURRENCIES.TRY).symbol;
export const curIsSuffix = () => (CURRENCIES[activeCurrency()] || CURRENCIES.TRY).suffix;
// Belirli bir para birimi KODUNA ait sembol (belgeler kendi para birimini SABİTLER — sistem birimi sonradan değişse de teklif/fatura kendi biriminde kalır). Eski "TL" kodu ₺'ye eşlenir.
export const symbolForCurrency = (code) => {
  const c = String(code || "").toUpperCase();
  if (c === "TL" || c === "TRY" || c === "") return "₺";
  return (CURRENCIES[c] || {}).symbol || String(code);
};

// Beyaz-etiket tenant markası (logo/ad/renk) — Ayarlar > Kurulum Sihirbazı / Marka'dan yazılır.
// Belgeler (fatura/fiş) bu değerleri kullanır; boşsa Groot varsayılanına döner.
export function getTenantBrand() {
  try { return JSON.parse((typeof localStorage !== "undefined" && localStorage.getItem("groot_branding")) || "null"); }
  catch { return null; }
}
export function setTenantBrand(b) {
  try { if (typeof localStorage !== "undefined") { b ? localStorage.setItem("groot_branding", JSON.stringify(b)) : localStorage.removeItem("groot_branding"); } }
  catch { /* yoksay */ }
}
export const docBrandName = () => (getTenantBrand()?.brand_name || "").trim() || (getCompanyProfile()?.name || "").trim() || COMPANY.brand;
export const docShowBrandText = () => !(getTenantBrand()?.doc_hide_brand);

// Belge İÇERİĞİ şablonları (Ayarlar > Tasarım > Belge Şablonu) — her belge türü için logo/marka/başlık/
// üst-alt satırlar ve QR görünürlüğü. Yazdırılan fiş/fatura/irsaliye/makbuz-dekont bu ayarları okur.
export const DOC_CONTENT_DEFAULTS = {
  receipt:  { show_logo: true, show_brand: false, title: "", header_lines: [], footer_lines: ["Bizi tercih ettiğiniz için teşekkürler!"], qr_verify: true, qr_survey: true, stamp: false },
  invoice:  { show_logo: true, show_brand: true,  title: "", header_lines: [], footer_lines: ["Bizi tercih ettiğiniz için teşekkürler!"], qr_verify: true, qr_survey: true, stamp: false },
  dispatch: { show_logo: true, show_brand: true,  title: "", header_lines: [], footer_lines: [], qr_verify: false, qr_survey: false, stamp: false },
  finance:  { show_logo: true, show_brand: true,  title: "", header_lines: [], footer_lines: [], qr_verify: true, qr_survey: false, stamp: false },
};
export function getDocContent() {
  try { return JSON.parse((typeof localStorage !== "undefined" && localStorage.getItem("groot_doc_content")) || "null"); }
  catch { return null; }
}
export function setDocContent(c) {
  try { if (typeof localStorage !== "undefined") { c ? localStorage.setItem("groot_doc_content", JSON.stringify(c)) : localStorage.removeItem("groot_doc_content"); } }
  catch { /* yoksay */ }
}
// Bir belge türünün etkin yapılandırması (varsayılan + kayıtlı birleşimi).
export function docCfg(type) {
  const all = getDocContent() || {};
  const d = DOC_CONTENT_DEFAULTS[type] || DOC_CONTENT_DEFAULTS.receipt;
  const saved = all[type] || {};
  return {
    ...d, ...saved,
    header_lines: Array.isArray(saved.header_lines) ? saved.header_lines.filter((l) => String(l).trim()) : d.header_lines,
    footer_lines: Array.isArray(saved.footer_lines) ? saved.footer_lines.filter((l) => String(l).trim()) : d.footer_lines,
  };
}
// Marka yazısı, hem per-belge show_brand hem de global "belgelerde marka gizle" ana anahtarına tabidir.
export const docShowBrand = (type) => docCfg(type).show_brand && docShowBrandText();

// Tek-kaynak firma bilgisi (Ayarlar > Firma Bilgileri) — belgelerde (fiş/fatura/irsaliye/makbuz/etiket)
// bu değerler önceliklidir; boşsa Groot varsayılanına döner. AuthContext girişte localStorage'a önbelleğe alır.
export function getCompanyProfile() {
  try { return JSON.parse((typeof localStorage !== "undefined" && localStorage.getItem("groot_company")) || "null"); }
  catch { return null; }
}
export function setCompanyProfile(p) {
  try { if (typeof localStorage !== "undefined") { p ? localStorage.setItem("groot_company", JSON.stringify(p)) : localStorage.removeItem("groot_company"); } }
  catch { /* yoksay */ }
}
const _cp = () => getCompanyProfile() || {};
export const docLegalName = () => (_cp().legal_name || "").trim() || (_cp().name || "").trim() || COMPANY.legal;
export const docAddress = () => (_cp().address || "").trim() || COMPANY.address;
export const docTaxLine = () => {
  const p = _cp();
  const off = (p.tax_office || "").trim();
  const no = (p.tax_no || "").trim();
  if (off || no) return `V.D/N : ${off}${off && no ? " - " : ""}${no}`;
  return COMPANY.taxLine;
};
export const docPhone = () => (_cp().phone || "").trim() || COMPANY.phone;
export const docEmail = () => (_cp().email || "").trim() || COMPANY.email;
// Belgelerde web/iletişim: firma web'i, yoksa firma e-postası, en son Groot varsayılanı.
export const docWeb = () => (_cp().web || "").trim() || (_cp().email || "").trim() || COMPANY.web;
// Yalnızca GERÇEK web adresi (fallback yok) — tekrar eden e-posta/web satırını önlemek için kullanılır.
export const docWebRaw = () => (_cp().web || "").trim();
// Belge sloganı/mottosu — firma profili slogan'ı, yoksa tenant marka slogan'ı, en son Groot varsayılanı.
export const docSlogan = () => (_cp().slogan || "").trim() || (getTenantBrand()?.slogan || "").trim() || COMPANY.tagline;
// Firma banka hesapları (Ayarlar > Firma Bilgileri) — fatura altında otomatik gösterilir. Boşsa Groot varsayılanı.
export const docBankAccounts = () => {
  const arr = _cp().bank_accounts;
  const clean = Array.isArray(arr) ? arr.filter((b) => (b?.iban || "").trim() || (b?.bank_name || "").trim()) : [];
  if (clean.length) return clean;
  return [{ bank_name: COMPANY.bankName, account_name: COMPANY.accountName, iban: COMPANY.iban }];
};

// Belgelerde kullanılan mutlak logo URL'i (izole yazdırma pencerelerinde de çözülür). Tenant logosu öncelikli.
export const logoUrl = () => {
  const t = getTenantBrand();
  const src = (t && t.logo_url) ? t.logo_url : grootLogo;
  return /^(data:|https?:)/.test(src) ? src : `${origin()}${src}`;
};

// Yüklenen belge görselleri (kaşe/mühür vb.) — izole yazdırma pencerelerinde de yüklenebilmesi için
// oturum token'ını query'ye ekler (serve_file ?auth= bekler). Boşsa "" döner.
const _backendBase = () => (process.env.REACT_APP_BACKEND_URL || origin()).replace(/\/$/, "");
export const docImageUrl = (u) => {
  if (!u) return "";
  if (/^(data:|blob:)/.test(u)) return u;
  const token = (typeof localStorage !== "undefined" && localStorage.getItem("groot_token")) || "";
  const path = /^https?:/.test(u) ? u : `${_backendBase()}${u}`;
  return `${path}${path.includes("?") ? "&" : "?"}auth=${encodeURIComponent(token)}`;
};

// Kaşe & İmza — TEK paylaşımlı görsel (Ayarlar > Marka & Logo). Belge türleri yalnızca aç/kapa (docCfg.stamp) yapar.
export const docStampUrl = () => (getTenantBrand()?.stamp_url || "").trim();
export const docStampPos = () => { const p = getTenantBrand()?.stamp_pos; return (p === "left" || p === "right" || p === "top") ? p : "center"; };

// Fiş altındaki karekodlar: sol = fiş doğrulama, sağ = müşteri değerlendirme anketi.
export const verifyUrl = (ref) => `${origin()}/dogrula?fis=${encodeURIComponent(ref || "")}`;
export const surveyUrl = (ref) => `${origin()}/anket${ref ? `?fis=${encodeURIComponent(ref)}` : ""}`;

// Belge renk temaları — fiş/fatura/irsaliye baskılarında kullanılır (Ayarlar > Belge Teması).
export const DOC_THEMES = {
  emerald:  { name: "Zümrüt (Varsayılan)", primary: "#064E3B", accent: "#EA580C", primarySoft: "#ECFDF5", primaryBorder: "#d1fae5", zebra: "#f6fdfa", accentSoft: "#fff7ed" },
  navy:     { name: "Lacivert & Amber",    primary: "#0F2A5B", accent: "#D97706", primarySoft: "#EFF4FF", primaryBorder: "#dbe6ff", zebra: "#f5f8ff", accentSoft: "#fff7ed" },
  bordo:    { name: "Bordo & Teal",        primary: "#7A1229", accent: "#0F766E", primarySoft: "#FEF2F4", primaryBorder: "#fbd5dd", zebra: "#fff6f8", accentSoft: "#ecfeff" },
  graphite: { name: "Grafit & Camgöbeği",  primary: "#1F2937", accent: "#0891B2", primarySoft: "#F3F4F6", primaryBorder: "#e5e7eb", zebra: "#f8fafc", accentSoft: "#ecfeff" },
  ocean:    { name: "Okyanus & Mercan",     primary: "#0C4A6E", accent: "#F97316", primarySoft: "#EFF6FF", primaryBorder: "#cfe4f5", zebra: "#f4f9ff", accentSoft: "#fff7ed" },
  plum:     { name: "Erik & Altın",         primary: "#4C1D45", accent: "#CA8A04", primarySoft: "#FBF3FB", primaryBorder: "#ecd6ea", zebra: "#fdf7fd", accentSoft: "#fefce8" },
  forest:   { name: "Orman & Lime",         primary: "#14532D", accent: "#65A30D", primarySoft: "#F0FDF4", primaryBorder: "#cdeccf", zebra: "#f5fdf6", accentSoft: "#f7fee7" },
  slate:    { name: "Antrasit & Kırmızı",   primary: "#0F172A", accent: "#DC2626", primarySoft: "#F1F5F9", primaryBorder: "#e2e8f0", zebra: "#f8fafc", accentSoft: "#fef2f2" },
  midnight: { name: "Gece Mavisi & Altın",  primary: "#0B1F3A", accent: "#EAB308", primarySoft: "#EEF3FB", primaryBorder: "#d5e2f2", zebra: "#f4f8fd", accentSoft: "#fefce8" },
  crimson:  { name: "Kızıl & Antrasit",     primary: "#7F1D1D", accent: "#334155", primarySoft: "#FEF2F2", primaryBorder: "#f6d5d5", zebra: "#fff7f7", accentSoft: "#f1f5f9" },
  royal:    { name: "Kraliyet Moru & Altın", primary: "#4338CA", accent: "#F59E0B", primarySoft: "#EEF0FE", primaryBorder: "#d7dcfb", zebra: "#f6f7ff", accentSoft: "#fffbeb" },
  espresso: { name: "Espresso & Bakır",     primary: "#3B2417", accent: "#C2703D", primarySoft: "#F7F1EC", primaryBorder: "#e9dcd0", zebra: "#fbf7f3", accentSoft: "#fdf1e7" },
  rose:     { name: "Gül & Antrasit",       primary: "#9F1239", accent: "#1F2937", primarySoft: "#FFF1F4", primaryBorder: "#fbd2dd", zebra: "#fff6f8", accentSoft: "#f3f4f6" },
  steel:    { name: "Çelik & Turuncu",      primary: "#334155", accent: "#EA580C", primarySoft: "#F1F5F9", primaryBorder: "#dde5ee", zebra: "#f7fafc", accentSoft: "#fff7ed" },
  olive:    { name: "Zeytin & Hardal",      primary: "#3F4A21", accent: "#CA8A04", primarySoft: "#F5F7EC", primaryBorder: "#e3e8cf", zebra: "#fafcf3", accentSoft: "#fefce8" },
  aqua:     { name: "Aqua & Mercan",        primary: "#0E7490", accent: "#F43F5E", primarySoft: "#ECFEFF", primaryBorder: "#cff0f5", zebra: "#f2fdff", accentSoft: "#fff1f3" },
  sunset:   { name: "Gün Batımı",           primary: "#9A3412", accent: "#0EA5E9", primarySoft: "#FFF3EC", primaryBorder: "#f6dcc9", zebra: "#fff8f3", accentSoft: "#eff9ff" },
  mint:     { name: "Nane & Antrasit",      primary: "#0F766E", accent: "#1F2937", primarySoft: "#EFFCF8", primaryBorder: "#cdeee7", zebra: "#f4fdfb", accentSoft: "#f3f4f6" },
  charcoal: { name: "Kömür & Altın",        primary: "#111827", accent: "#D4AF37", primarySoft: "#F3F4F6", primaryBorder: "#e2e5ea", zebra: "#f8fafc", accentSoft: "#fdf6e3" },
  wine:     { name: "Şarap & Krem",         primary: "#601530", accent: "#B45309", primarySoft: "#FBF0F3", primaryBorder: "#efd2db", zebra: "#fdf6f8", accentSoft: "#fdf3e7" },
  sky:      { name: "Gökyüzü & Lacivert",   primary: "#075985", accent: "#1E3A8A", primarySoft: "#EFF8FF", primaryBorder: "#cfe6f7", zebra: "#f4fafe", accentSoft: "#eef2ff" },
  sand:     { name: "Kum & Okyanus",        primary: "#78350F", accent: "#0891B2", primarySoft: "#FBF5EC", primaryBorder: "#ecdcc6", zebra: "#fdf9f2", accentSoft: "#ecfeff" },
  violet:   { name: "Menekşe & Lime",       primary: "#5B21B6", accent: "#84CC16", primarySoft: "#F5F0FE", primaryBorder: "#e0d3fb", zebra: "#faf7ff", accentSoft: "#f7fee7" },
};

export const activeDocThemeName = () =>
  (typeof localStorage !== "undefined" && localStorage.getItem("groot_doc_theme")) || "emerald";

// Özel (custom) belge renkleri — kullanıcı 2 renk seçebilir; localStorage'da tutulur.
export function getCustomDocColors() {
  try { return JSON.parse((typeof localStorage !== "undefined" && localStorage.getItem("groot_doc_custom")) || "null"); }
  catch { return null; }
}
export const buildDocTheme = (primary, accent) => ({
  name: "Özel Renkler", primary: primary || "#064E3B", accent: accent || "#EA580C",
  primarySoft: "#F3F4F6", primaryBorder: "#e5e7eb", zebra: "#f8fafc", accentSoft: "#fff7ed",
});

// Aktif belge teması; "custom" ise özel renkler, sonra tenant marka renkleri (varsa) primary/accent'i ezer.
export const activeDocTheme = () => {
  const key = activeDocThemeName();
  let base;
  if (key === "custom") { const c = getCustomDocColors() || {}; base = buildDocTheme(c.primary, c.accent); }
  else base = DOC_THEMES[key] || DOC_THEMES.emerald;
  const t = getTenantBrand();
  if (t && (t.primary || t.accent)) return { ...base, primary: t.primary || base.primary, accent: t.accent || base.accent };
  return base;
};

// Belge şablon stilleri (yalnız görünüm varyantı; "klasik" = mevcut varsayılan, DEĞİŞMEZ).
export const DOC_TEMPLATES = {
  klasik:  { name: "Klasik (Varsayılan)", desc: "Mevcut standart tasarım" },
  modern:  { name: "Modern",  desc: "Kalın başlık bandı, büyük başlık" },
  minimal: { name: "Minimal", desc: "Çizgisel, renksiz başlık, sade" },
  zarif:   { name: "Zarif",   desc: "Serif başlık, ince çerçeve" },
  kompakt: { name: "Kompakt", desc: "Küçük font, sık yerleşim" },
  kurumsal: { name: "Kurumsal", desc: "Çerçeveli başlık, çift çizgi — resmî ve ağırbaşlı" },
  premium:  { name: "Premium",  desc: "Kalın vurgu bandı, altın çizgi — elit görünüm" },
  ferah:    { name: "Ferah",    desc: "Bol boşluk, açık tonlu tablo — modern hava" },
  kutu:     { name: "Kutu",     desc: "Bölümler kutulanmış — net ve düzenli" },
};
export const activeDocTemplate = () =>
  (typeof localStorage !== "undefined" && localStorage.getItem("groot_doc_template")) || "klasik";

// Giriş ekranı temaları (dekoratif ışık renkleri; "standart" = varsayılan).
export const LOGIN_THEMES = {
  standart: { name: "Standart (Varsayılan)", vars: { "--lb1": "#065f46", "--lb2": "#EA580C", "--lb3": "#34d399" } },
  gece:     { name: "Gece",       vars: { "--lb1": "#1e3a8a", "--lb2": "#f59e0b", "--lb3": "#38bdf8" } },
  mor:      { name: "Mor Işıltı", vars: { "--lb1": "#4c1d95", "--lb2": "#ec4899", "--lb3": "#a78bfa" } },
  bordo:    { name: "Bordo",      vars: { "--lb1": "#7f1d1d", "--lb2": "#0f766e", "--lb3": "#fb7185" } },
  okyanus:  { name: "Okyanus",    vars: { "--lb1": "#0c4a6e", "--lb2": "#f97316", "--lb3": "#22d3ee" } },
  gunbatimi: { name: "Gün Batımı", vars: { "--lb1": "#b45309", "--lb2": "#db2777", "--lb3": "#fbbf24" } },
  zumrutgece: { name: "Zümrüt Gece", vars: { "--lb1": "#064e3b", "--lb2": "#0ea5e9", "--lb3": "#34d399" } },
  neon:     { name: "Neon Işıltı", vars: { "--lb1": "#4c1d95", "--lb2": "#06b6d4", "--lb3": "#f472b6" } },
  komur:    { name: "Kömür & Altın", vars: { "--lb1": "#1f2937", "--lb2": "#d4af37", "--lb3": "#9ca3af" } },
  buz:      { name: "Buz Mavisi",  vars: { "--lb1": "#0e7490", "--lb2": "#6366f1", "--lb3": "#67e8f9" } },
  yesilcay: { name: "Yeşil Çay",   vars: { "--lb1": "#3f6212", "--lb2": "#ca8a04", "--lb3": "#a3e635" } },
  lavanta:  { name: "Lavanta",     vars: { "--lb1": "#5b21b6", "--lb2": "#f472b6", "--lb3": "#c4b5fd" } },
  gulkurusu: { name: "Gül Kurusu", vars: { "--lb1": "#9f1239", "--lb2": "#e11d48", "--lb3": "#fda4af" } },
  antrasit: { name: "Antrasit",    vars: { "--lb1": "#0f172a", "--lb2": "#f97316", "--lb3": "#64748b" } },
  turkuaz:  { name: "Turkuaz",     vars: { "--lb1": "#0f766e", "--lb2": "#f59e0b", "--lb3": "#5eead4" } },
  safir:    { name: "Safir",       vars: { "--lb1": "#1e40af", "--lb2": "#7c3aed", "--lb3": "#93c5fd" } },
  amber:    { name: "Amber",       vars: { "--lb1": "#92400e", "--lb2": "#dc2626", "--lb3": "#fcd34d" } },
  orman:    { name: "Orman",       vars: { "--lb1": "#14532d", "--lb2": "#65a30d", "--lb3": "#86efac" } },
  gece2:    { name: "Derin Uzay",  vars: { "--lb1": "#111827", "--lb2": "#6d28d9", "--lb3": "#818cf8" } },
  mercan:   { name: "Mercan",      vars: { "--lb1": "#9a3412", "--lb2": "#0d9488", "--lb3": "#fdba74" } },
  siyahbeyaz: { name: "Mono",      vars: { "--lb1": "#18181b", "--lb2": "#52525b", "--lb3": "#d4d4d8" } },
};
export const activeLoginThemeName = () =>
  (typeof localStorage !== "undefined" && localStorage.getItem("groot_login_theme")) || "standart";
export const activeLoginTheme = () => LOGIN_THEMES[activeLoginThemeName()] || LOGIN_THEMES.standart;

// Giriş ekranı sol marka panelinin YERLEŞİM şablonları ("klasik" = mevcut varsayılan, DEĞİŞMEZ).
export const LOGIN_LAYOUTS = {
  klasik:     { name: "Klasik (Varsayılan)", desc: "Başlık + 4 özellik kartı (ızgara)" },
  minimal:    { name: "Minimal",             desc: "Yalnız başlık ve slogan, kart yok" },
  liste:      { name: "Liste",               desc: "Özellikler dikey liste halinde" },
  istatistik: { name: "İstatistik",          desc: "Rakam vurgulu bilgi blokları" },
  merkez:     { name: "Odak (Merkez)",       desc: "Ortalanmış büyük başlık" },
  kartust:    { name: "Üst Rozetler",        desc: "Başlık üstünde küçük rozet şeridi" },
  bolme:      { name: "Bölme",               desc: "İki sütun: başlık + özellik listesi" },
  vitrin:     { name: "Vitrin",              desc: "Büyük tek vurgu + alt istatistik" },
  serit:      { name: "Şerit",               desc: "Yatay ince şerit özellikler" },
};
export const activeLoginLayout = () =>
  (typeof localStorage !== "undefined" && localStorage.getItem("groot_login_layout")) || "klasik";

// Giriş ekranı METİNLERİ — tümü Tasarım Stüdyosu'ndan düzenlenebilir ("POS" → "Kamyon" gibi).
export const LOGIN_TEXT_DEFAULTS = {
  title: "Tek çekirdek,",
  title_accent: "tüm işletme.",
  subtitle: "Toptan, Perakende, E-Ticaret ve Depo Yönetimi Tek Çekirdekte",
  features: [
    { label: "Perakende POS", sub: "Hızlı kasa" },
    { label: "Depo & Stok", sub: "Çok lokasyon" },
    { label: "E-Ticaret", sub: "Pazaryeri" },
    { label: "Lojistik", sub: "Sevkiyat" },
  ],
  stats: [
    { big: "1.600+", label: "Aktif Ürün" },
    { big: "7/24", label: "Bulut Erişim" },
    { big: "Çoklu", label: "Lokasyon & Sektör" },
  ],
};
export const activeLoginTexts = () => {
  try {
    const raw = typeof localStorage !== "undefined" && localStorage.getItem("groot_login_texts");
    if (raw) return { ...LOGIN_TEXT_DEFAULTS, ...JSON.parse(raw) };
  } catch (e) {}
  return LOGIN_TEXT_DEFAULTS;
};

// Beyaz-etiket: tenant marka renklerini tüm arayüze uygular (runtime CSS override, geri alınabilir).
export function applyBrandColors(primary, accent) {
  if (typeof document === "undefined") return;
  const id = "tenant-brand-vars";
  let el = document.getElementById(id);
  if (!primary && !accent) { if (el) el.remove(); return; }
  if (!el) { el = document.createElement("style"); el.id = id; document.head.appendChild(el); }
  const p = primary || "#064E3B"; const a = accent || "#EA580C";
  el.textContent =
    `.brand-green{color:${p} !important}` +
    `.bg-brand-green{background-color:${p} !important}` +
    `.bg-brand-green-600{background-color:${p} !important;filter:brightness(0.9)}` +
    `.brand-orange{color:${a} !important}` +
    `.bg-brand-orange{background-color:${a} !important}`;
}

// ---------------- Global Yazı Tipi (uygulama arayüzü + belge önizleme) ----------------
export const UI_FONTS = {
  sistem:   { name: "Varsayılan", stack: "" },
  modern:   { name: "Modern (Sistem)", stack: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif" },
  net:      { name: "Net (Segoe UI)", stack: "'Segoe UI', system-ui, Roboto, sans-serif" },
  klasik:   { name: "Klasik (Georgia)", stack: "Georgia, 'Times New Roman', serif" },
  zarif:    { name: "Zarif (Palatino)", stack: "'Palatino Linotype', Palatino, 'Book Antiqua', serif" },
  yuvarlak: { name: "Yuvarlak (Trebuchet)", stack: "'Trebuchet MS', 'Segoe UI', sans-serif" },
  genis:    { name: "Geniş (Verdana)", stack: "Verdana, Geneva, sans-serif" },
  tahoma:   { name: "Tahoma", stack: "Tahoma, Geneva, sans-serif" },
  kesin:    { name: "Kesin (Arial)", stack: "Arial, Helvetica, sans-serif" },
  okunakli: { name: "Okunaklı (Calibri)", stack: "Calibri, Candara, 'Segoe UI', sans-serif" },
  daktilo:  { name: "Daktilo (Mono)", stack: "'Courier New', Courier, monospace" },
};
export const UI_FONT_SCALES = { kucuk: 0.92, normal: 1, buyuk: 1.08, cokbuyuk: 1.16 };
export const UI_FONT_WEIGHTS = { normal: 400, orta: 500, kalin: 600 };

// Uygulama arayüzüne global yazı tipi/boyut/kalınlık uygular (runtime CSS, geri alınabilir).
export function applyGlobalFont(cfg) {
  if (typeof document === "undefined") return;
  const id = "app-font-vars";
  let el = document.getElementById(id);
  const fam = (UI_FONTS[cfg?.font_family] || {}).stack || "";
  const scale = UI_FONT_SCALES[cfg?.font_scale] || 1;
  const weight = UI_FONT_WEIGHTS[cfg?.font_weight] || 400;
  if (!fam && scale === 1 && weight === 400) { if (el) el.remove(); return; }
  if (!el) { el = document.createElement("style"); el.id = id; document.head.appendChild(el); }
  el.textContent =
    `html{font-size:${(16 * scale).toFixed(2)}px}` +
    (fam ? `body,button,input,select,textarea{font-family:${fam}}` : "") +
    (weight !== 400 ? `body{font-weight:${weight}}` : "");
}

// Belge önizleme/baskıda kullanılacak yazı tipi (varsayılan Arial — baskı sadakati için).
export const docFontFamily = () => {
  const b = getTenantBrand();
  return (UI_FONTS[b?.font_family] || {}).stack || "Arial, sans-serif";
};

// Kullanıcı AÇIKÇA bir yazı tipi seçtiyse belge kök stiline uygulanacak stack; seçmediyse "" döner
// (böylece şablonların kendi fontu — ör. "Zarif" Georgia — bozulmaz).
export const docFontOverride = () => (UI_FONTS[getTenantBrand()?.font_family] || {}).stack || "";
